<template>
    <div v-if="cardType=='dataSupervise'">
        <p class="num" :style="numStyleObj" :title="endVal" style="font-size:3vh">
            <span style="font-family: MaravaleExpanded;">{{data}}</span>{{ unit }}
        </p>
        <p class="name" :style="nameStyleObj">{{introText}}</p>
    </div>
    <div v-else-if="cardType=='newDataSupervise'">
        <p class="num" :style="numStyleObj" style="font-size:3vh">
            <span v-if="startDataVal!='-1'" :title="startDataVal"><span
                style="font-family: MaravaleExpanded;">{{startData}}</span>{{ startUnit }}/</span>
            <span style="font-family: MaravaleExpanded;" :title="endVal">{{data}}</span><span
            :title="endVal">{{ unit }}</span>
        </p>
        <p class="name text-area" :style="nameStyleObj">{{introText}}</p>
    </div>
    <div v-else :title="endVal">
        <p :class="className"
           :style="{textAlign: 'center', color: color, fontSize: countSize, fontWeight: countWeight}">
            <span v-cloak :id="idName">{{ startVal }}</span><span style="font-family: initial;">{{ unit }}</span>
            <span :style="{fontSize: introTextSize}">{{introText}}</span>
        </p>
        <slot name="intro"></slot>
    </div>
</template>

<script>
    import CountUp from 'countup';

    export default {
        data() {
            return {
                unit: '',
                demo: {},
                data: "",
                startData: "",
                startUnit: ""
            };
        },
        name: 'number-countUp',
        props: {
            idName: String,
            className: String,
            cardType: String,
            startVal: {
                type: Number,
                default: 0
            },
            startDataVal: {
                type: Number,
                default: 0
            },
            endVal: {
                type: Number,
                default: 0,
                required: true
            },
            decimals: {
                type: Number,
                default: 0
            },
            duration: {
                type: Number,
                default: 2
            },
            delay: {
                type: Number,
                default: 500
            },
            numStyleObj: Object,
            nameStyleObj: Object,
            options: {
                type: Object,
                default: () => {
                    return {
                        useEasing: true,
                        useGrouping: true,
                        separator: ',',
                        decimal: '.',
                        suffix: ''
                    };
                }
            },
            color: String,
            countSize: {
                type: String,
                default: '20px'
            },
            countWeight: {
                type: Number,
                default: 700
            },
            introText: [String, Number],
            introTextSize: {
                type: String,
                default: '12px'
            },
            isConvert: {
                type: Number,
                default: -1
            }
        },
        watch: {
            endVal(val) {
                if (val != undefined) {
                    let endVal = "";
                    if (this.isConvert === 1) {
                        let res = this.transformValue(this.endVal);
                        endVal = res.val;
                        this.unit = res.unit;
                    } else {
                        endVal = this.endVal;
                        this.unit = ""
                    }
                    let demo = {};
                    if (this.cardType == "dataSupervise" || this.cardType == "newDataSupervise") {
                        this.data = endVal;
                    } else {
                        this.demo = demo = new CountUp(this.idName, this.startVal, endVal, this.decimals, this.duration, this.options);
                        if (!demo.error) {
                            demo.start();
                        }
                    }
                }
            },
            startDataVal(val) {
                if (val != undefined) {
                    let startVal = "";
                    if (this.isConvert === 1) {
                        let staRes = this.transformValue(this.startDataVal);
                        startVal = staRes.val;
                        this.startUnit = staRes.unit;
                    } else {
                        startVal = this.startDataVal;
                    }
                    let demo = {};
                    this.startData = startVal;
                }
            }
        },
        methods: {
            // && val < 1000000
            transformValue(val) {
                let endVal = 0;
                let unit = '';
                if (val < 1000) {
                    endVal = val;
                } else if (val >= 1000 && val < 10000) {
                    endVal = parseInt(val / 1000);
                    unit = 'K+';
                } else if (val >= 10000) {
                    endVal = parseInt(val / 10000);
                    unit = 'w+';
                }
                // else if (val >= 1000000 && val < 10000000000) {
                //     endVal = parseInt(val / 1000000);
                //     unit = 'M+';
                // } else {
                //     endVal = parseInt(val / 1000000000);
                //     unit = 'B+';
                // }
                return {
                    val: endVal,
                    unit: unit
                };
            }
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.endVal != undefined) {
                        // let res = this.transformValue(this.endVal);
                        // let endVal = res.val;
                        // this.unit = res.unit;
                        let endVal = "";
                        if (this.isConvert === 1) {
                            let res = this.transformValue(this.endVal);
                            endVal = res.val;
                            this.unit = res.unit;
                        } else {
                            endVal = this.endVal
                        }
                        let demo = {};
                        if (this.cardType == "dataSupervise" || this.cardType == "newDataSupervise") {
                            this.data = endVal;
                        } else {
                            this.demo = demo = new CountUp(this.idName, this.startVal, endVal, this.decimals, this.duration, this.options);
                            if (!demo.error) {
                                demo.start();
                            }
                        }
                    }
                    if (this.startDataVal != undefined) {
                        let startVal = "";
                        if (this.isConvert === 1) {
                            let staRes = this.transformValue(this.startDataVal);
                            startVal = staRes.val;
                            this.startUnit = staRes.unit;
                        } else {
                            startVal = this.startDataVal;
                        }
                        let demo = {};
                        this.startData = startVal;
                    }
                }, this.delay);
            });
        }
    };
</script>

<style lang="scss" scoped>
    .text-area {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
</style>
